export default "__VITE_ASSET__KJKTieL8__"